import angular from 'angular';
import { routes } from "./pontos.routes";
import DirectoryPontosController from "./directory/directory.controller";
export default angular.module('app.elv.pontos', [])
    .config(routes)
    .controller('DirectoryPontosController', DirectoryPontosController)
    .name;
